export var Status;
(function (Status) {
    /** Unknown status. */
    Status["UNKNOWN"] = "UNKNOWN";
    /** Initial status when the referred friend joins the site as a member. */
    Status["SIGN_UP_COMPLETED"] = "SIGN_UP_COMPLETED";
    /** Status after the referred friend completes a specific action, such as making a purchase. */
    Status["ACTIONS_COMPLETED"] = "ACTIONS_COMPLETED";
})(Status || (Status = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
//# sourceMappingURL=types.impl.js.map